import React from 'react';

const InvAclimatacion = () => {
  return (
    <React.Fragment>
      <div className="w-full p-3 right-0">
        <div className="bg-white border rounded shadow-xl">
          <div className="border-b rounded-t p-3 bg-orange-900">
            <h5 className="font-bold uppercase text-white">Inventario de Aclimatación</h5>
            <p className="text-white text-sm">Configuración del Inventario</p>
          </div>
          <div className="p-5 rounded-b">
            {/* ---- CONTENIDO --- */}
            <p>
            </p>
          </div>
        </div>
      </div>
  
    </React.Fragment>
  );
}


export default InvAclimatacion;